import Box from '@/common/components/Box';
import Skeleton from '@/common/components/Skeleton';

const GeneralPoliticsSectionLoadingState = () => {
  return (
    <Box className='p-4 flex flex-col gap-4'>
      <div className="flex items-center gap-x-3">
        <Skeleton width={75} height={34} className='bg-white-100' />

        <Skeleton width={80} height={28} />
      </div>

      <div className='flex flex-col gap-4'>
        <div className='flex items-center gap-3 flex-wrap'>
          <Skeleton width={135} />

          {new Array(4).fill(null).map((_, i) => (
            <div key={`product_category_${i}`} className='flex items-center gap-1 text-white-400'>
              <Skeleton width={24} height={24} className='bg-white-100' />

              <Skeleton width={80} />
            </div>
          ))}
        </div>

        <div className='flex items-center gap-3'>
          <Skeleton width={130} />

          <div className='flex items-center gap-1 text-white-400'>
            <Skeleton width={24} height={24} circle className='bg-white-100' />

            <Skeleton width={120} />
          </div>
        </div>

        <div className='flex items-center gap-3'>
          <Skeleton width={165} />

          <div className='flex items-center gap-1 text-white-400'>
            <Skeleton width={24} height={24} circle className='bg-white-100' />

            <Skeleton width={120} />
          </div>
        </div>
      </div>
    </Box>
  )
}

export default GeneralPoliticsSectionLoadingState;
